import React, { Component } from 'react';
import { IoCloseOutline } from "react-icons/io5";
import './OpenPopulationStatusModal.css';
// import populationStatusImg from '../../../icons/sensor_status/populationStatus.png'; // Adjust the path as necessary
import { ReactComponent as Exclamation } from '../../../icons/sensor_status/Exclamation.svg'


export interface OpenPopulationStatusModalProps {
  clickedFloor: string;
  closePopulationStatus: () => void;
}

export default class OpenPopulationStatusModal extends Component<OpenPopulationStatusModalProps>{
  render(){
    const { closePopulationStatus } = this.props;
    return (
      <div className="image-modal-backdrop">            
        <div className="image-modal-content"> 
          <div className="image-modal-title">
            <Exclamation />
            <div style={{color: 'white', fontWeight: 'bold', marginLeft: 10, marginRight: 2}} >실시간 유동인구 상세 현황 - </div>
            <div style={{color: '#03A8A8', fontWeight: 'bold'}} >{this.props.clickedFloor}</div>            
          </div>                       
          <IoCloseOutline className="close-icon" onClick={closePopulationStatus} />
          {/* <img src={require('../../../icons/sensor_status/populationStatus2.png')} width="100%" height='100%' alt="Population Status" /> */}
        </div>
      </div>
    );
  }
};
